import React, { Fragment, useState } from 'react'
import { Container } from 'reactstrap'

import TabHeader from './TabHeader'

const Tabs = ({ tabs }) => {
  const [tabIndex, setTabIndex] = useState(0)

  return (
    <Fragment>
      <div style={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
        <Container>
          <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
            {tabs.map((tab, index) => (
              <TabHeader
                key={index}
                isActive={index === tabIndex}
                onClick={() => setTabIndex(index)}
                label={tab.label}
              />
            ))}
          </div>
        </Container>
      </div>

      {tabs[tabIndex].component}
    </Fragment>
  )
}

export default Tabs
